import * as React from 'react';

import classNames from 'classnames';

import { getTranslation } from '@base/utils';

import { Link } from '@ui';

import { IMainMenuUserProps } from './types';

import * as s from './MainMenuUser.scss';

export const MainMenuUser = (props: IMainMenuUserProps) => {
	const {
		className,
		name = '',
		link = '',
		avatar = '',
		onClick,
	} = props;
	const t = getTranslation('components.MainMenu.MainMenuUser');

	const onLinkClick = () => {
		if (link && onClick) {
			onClick();
		}
	};

	return <Link onClick={onLinkClick} to={link} className={classNames(s.block, className)} isSimpleLink>
		<span className={s.avatar} style={{ backgroundImage: `url(${avatar})` }} />
		<span className={s.user}>
			<span className={s.title}>{name}</span>
			<span className={s.description}>{t('goToProfile')}</span>
		</span>
	</Link>;
};
